module.exports = __webpack_public_path__ + "media/assets/images/zidosya_first_view-3d803928a36d4e9a898da3f7c2bc63f3.svg";